import React, { useState } from 'react';
import type { DistributedOmit } from 'type-fest';
import type { ButtonProps } from '../components/Button';
import Button from '../components/Button';
import FloatingCard from '../components/FloatingCard';
import HoverView from '../components/HoverView';
import Link from '../utils/router/Link';
import userPath from '../utils/url/userPath';
import * as styles from './AdminListButton.module.scss';
import UserRow from './UserRow';
import { useAllAdmins } from './useAllUsers';

type AdminListButtonProps = DistributedOmit<ButtonProps, 'onClick'>;

const AdminListButton = (props: AdminListButtonProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const admins = useAllAdmins();

  return (
    <HoverView
      placement="bottom-start"
      hoverDelay="fast"
      open={isOpen}
      onOpenChange={setIsOpen}
      view={
        <FloatingCard noArrow onClick={() => setIsOpen(false)}>
          <div className={styles.userList}>
            {admins.map((admin) => (
              <Link
                key={admin.id}
                className={styles.row}
                to={userPath(admin)}
                newTab
              >
                <UserRow user={admin} />
              </Link>
            ))}
          </div>
        </FloatingCard>
      }
    >
      <Button {...props} onClick={() => setIsOpen(true)} />
    </HoverView>
  );
};

export default AdminListButton;
